<div class="about center-align {{ theme }}-theme">
	<img class="logo" src="/resources/img/logo/logo_blue_no_text.svg" alt="logo" />
	<h3>Online Video Platform</h3>

	<p>{{ "VERSION" | translate }}: {{ release }}<br />
	<small>{{ buildDate | date }}</small></p>

	<hr />
	<div class="gdpr">
		<p><strong>
			{{ "GDPR_DATA_PROTECTION_STATEMENT" | translate }}
		</strong></p>
		<p>
			{{ "GDPR_MESSAGE" | translate }}
		</p>
	</div>

	<hr />

	<p><strong>Blue Billywig</strong><br />
		Catharina van Renneslaan 20<br />
		{{ "BB_POSTAL_CODE" | translate }}<br />
		{{ "NETHERLANDS" | translate }}</p>

	<p><a href="//bluebillywig.com" target="_blank">bluebillywig.com</a> | <a href="//support.bluebillywig.com" target="_blank">support.bluebillywig.com</a></p>

	<ng-content></ng-content>

	<p [hasPermission]="'root'" class="root"><a class="button" [attr.href]="serverUrl + '/sapi/publication'" target="_blank">Publication Data</a></p>
</div>
